import { gql } from '@apollo/client';

export const RUN_PORTFOLIO_OPTIMIZER = gql`
  mutation runPortfolioOptimizer($input: RunPortfolioOptimizerInput!) {
    runPortfolioOptimizer(input: $input) {
      portfolioOptimizer {
        id
        state
      }
    }
  }
`;

export const CREATE_SUB_TRADE_REQUESTS = gql`
  mutation createSubTradeRequests($input: CreateSubTradeRequestsInput!) {
    createSubTradeRequests(input: $input)
  }
`;

export const VERIFY_SUB_TRADE_REQUESTS = gql`
  mutation verifySubTradeRequests($input: VerifySubTradeRequestsInput!) {
    verifySubTradeRequests(input: $input)
  }
`;

export const CANCEL_SUB_TRADE_REQUESTS_BY_ID = gql`
  mutation cancelSubTradeRequestsById(
    $input: CancelSubTradeRequestsByIdInput!
  ) {
    cancelSubTradeRequestsById(input: $input)
  }
`;

export const BUCKET_SUB_TRADE_REQUESTS = gql`
  mutation bucketSubTradeRequests($input: BucketSubTradeRequestsInput!) {
    bucketSubTradeRequests(input: $input)
  }
`;

export const GENERATE_BULK_TRADES = gql`
  mutation generateBulkTrades($input: GenerateBulkTradesInput!) {
    generateBulkTrades(input: $input) {
      bulkTradeRun {
        id
        state
      }
    }
  }
`;

export const UPDATE_SUB_TRADE_REQUESTS = gql`
  mutation updateSubTradeRequests($input: UpdateSubTradeRequestsInput!) {
    updateSubTradeRequests(input: $input)
  }
`;

export const TRANSITION_PORTFOLIO_OPTIMIZER = gql`
  mutation transitionPortfolioOptimizer(
    $input: TransitionPortfolioOptimizerInput!
  ) {
    transitionPortfolioOptimizer(input: $input) {
      portfolioOptimizer {
        id
        state
      }
    }
  }
`;

export const TRANSITION_BULK_TRADE_RUN = gql`
  mutation transitionBulkTradeRun($input: TransitionBulkTradeRunInput!) {
    transitionBulkTradeRun(input: $input) {
      bulkTradeRun {
        id
        state
        updatedAt
      }
    }
  }
`;

export const REMOVE_TRADE_REQUEST = gql`
  mutation removeBulkTrade($tradeRequestId: ObjectID!) {
    removeBulkTrade(tradeRequestId: $tradeRequestId) {
      success
    }
  }
`;
